import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { HOUSEKEEPING_VIEW } from '../../../constants/DashboardConst';
import { selectedHotelSelector } from '../../property/propertySlice';
import {
  dashboardViewStateSelector,
  fetchHousekeepingOrdersList,
  housekeepingOrdersSelector,
  setDashboardViewState,
} from '../DashboardSlice';
import DashboardHousekeepingList from './dashboard-housekeeping-list/DashboardHousekeepingList';
import DashboardHousekeepingView from './dashboard-housekeeping-view/DashboardHousekeepingView';
import { decryptLocalStorage } from '../../../utils/authUtils';
import {
  RBAC_PERMISSION_LEVEL_NO_ACCESS,
  RBAC_TYPE_DASHBOARD_SERVICE_REQUEST,
} from '../../../constants/RoleConsts';

const DashboardHousekeeping = (props) => {
  const { permissions, showLoader = () => {} } = props;
  const selectedHotel = useSelector(selectedHotelSelector);
  const dashboardViewState = useSelector(dashboardViewStateSelector);
  const allOrdersList = useSelector(housekeepingOrdersSelector);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const location = useLocation();
  const currentFilterFromLocation = location?.state?.status;

  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    let isSelectedHotel = selectedHotel || decryptLocalStorage('hotelId');
    if (!isSelectedHotel) {
      history.push('/properties');
    }
  }, [history, selectedHotel]);

  useEffect(() => {
    if (
      selectedHotel &&
      permissions &&
      permissions[RBAC_TYPE_DASHBOARD_SERVICE_REQUEST] !== RBAC_PERMISSION_LEVEL_NO_ACCESS
    ) {
      dispatch(fetchHousekeepingOrdersList(selectedHotel));
    }
  }, [selectedHotel, permissions, dispatch]);

  const onViewToggle = (type, status, obj) => {
    dispatch(setDashboardViewState({ type: type, status: status, obj: obj }));
  };

  const switchViewContent = (inpState) => {
    switch (inpState.type) {
      case HOUSEKEEPING_VIEW:
        return (
          <DashboardHousekeepingView
            obj={dashboardViewState.obj}
            onViewToggle={onViewToggle}
            hotelId={selectedHotel}
            showLoader={showLoader}
          />
        );
      default:
        break;
    }
  };

  return (
    <>
      {dashboardViewState.status && <>{switchViewContent(dashboardViewState)}</>}
      {!dashboardViewState.status && (
        <>
          <DashboardHousekeepingList
            onViewToggle={onViewToggle}
            hotelId={selectedHotel}
            permissions={permissions}
            allOrdersList={allOrdersList}
            onsetPage={(e) => setPage(e)}
            page={page}
            onsetRowsPerPage={(e) => setRowsPerPage(e)}
            rowsPerPage={rowsPerPage}
            currentFilterFromLocation={currentFilterFromLocation}
          />
        </>
      )}
    </>
  );
};

export default DashboardHousekeeping;
